export const GENDER_OPTIONS = {
  Male: "M",
  Female: "F",
  "Non-Binary": "N",
  "Non-Specified": "U",
};
